import { actionTypes } from '../../constants';

export const navigateToNextScreen = (nextScreen, isBack = false) => ({
  type: actionTypes.REDIRECT_NEXT_SCREEN,
  path: nextScreen,
  isBack,
});

export const navigateToEditScreen = screen => ({
  type: actionTypes.NAVIGATE_TO_EDIT_SCREEN,
  editPath: screen,
});

export const navigateToBrochurware = () => ({
  type: actionTypes.NAVIGATE_TO_BROCHUREWARE,
});

export const navigateToErrorScreen = () => ({
  type: actionTypes.REDIRECT_NEXT_SCREEN,
  path: '/error',
});

export const redirectURL = () => ({
  type: actionTypes.REDIRECT_URL
});
